import {FC, useEffect, useState} from 'react'
import {GetReceptionResponse, Reception} from './core/_models'
import {ActionsCell} from './table/ActionsCell'
import {ID} from '../../../../../_metronic/helpers'
import {STATUS_PROTOCOLO} from '../../constants'
import {FormatDate} from '../../../../utils'

type Props = {
  handleFormModal: () => void
  handleById: (id: ID) => void
  handleDelete: (id: ID) => void
  receptions: GetReceptionResponse
  isLoading?: boolean
}

const ReceptionPageList: FC<Props> = ({
  handleFormModal,
  handleById,
  handleDelete,
  receptions,
  isLoading,
}) => {
  const [receptionList, setReceptionList] = useState<Reception[]>([])

  useEffect(() => {
    if (receptions.data.length > 0) {
      const r = receptions.data

      const itensUnicos: string[] = []

      const arraySemDuplicatas: Reception[] = []

      r.forEach((item: Reception) => {
        if (item.protocolo?.numero) {
          if (!itensUnicos.includes(item.protocolo?.numero)) {
            itensUnicos.push(item.protocolo?.numero)
            arraySemDuplicatas.push(item)
          }
        }
      })

      setReceptionList(arraySemDuplicatas)
    }
  }, [receptions])

  return (
    <table className='table table-hover table-rounded table-striped border gy-7 gs-7'>
      <thead>
        <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
          <th>Protocolo</th>
          <th>Data da recepção</th>
        </tr>
      </thead>
      <tbody>
        {isLoading && (
          <tr>
            <td colSpan={2}>Carregando...</td>
          </tr>
        )}
        {!isLoading &&
          receptionList.map((repection) => (
            <tr>
              <td>{repection.protocolo?.numero}</td>
              <td>{FormatDate(repection.dataCriacao?.toString())}</td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}

export default ReceptionPageList
